import React, { useEffect, useState } from "react";

import { collection, query, where, orderBy, limit, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import NotesContainerGlobalMedicalMobile from "../Notes/NotesContainerGlobalMedicalMobile";

function MedicalNotesAllMobile(props) {
  const [notes, setNotes] = useState([]);

  useEffect(() => {
    const notesRef = collection(db, "notes");
    const q = query(
      notesRef,
      where("noteType", "==", "medicalNote"),
      orderBy("effectiveDateTime", "desc"),
      limit(50)
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const notesData = [];
      querySnapshot.forEach((doc) => {
        notesData.push({ id: doc.id, ...doc.data() });
      });
      setNotes(notesData);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <div className="notes-container-global">
      {notes.map((note) => {
        const dateOptions = {
          day: "numeric",
          month: "short",
          year: "numeric",
        };

        const dateOptions2 = {
          day: "numeric",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        };

        const timeOptions = {
          hour: "2-digit",
          minute: "2-digit",
        };

        const formattedTimestamp = note.createdAt
          ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
              note.createdAt.toDate()
            )
          : "";

        const formattedLastModification = note.updateAt
          ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
              note.updateAt.toDate()
            )
          : "";

        const formattedDate = note.effectiveDateTime
          ? new Intl.DateTimeFormat("en-EN", dateOptions).format(
              note.effectiveDateTime.toDate()
            )
          : "";

        const formattedTime = note.effectiveDateTime
          ? new Intl.DateTimeFormat("en-EN", timeOptions).format(
              note.effectiveDateTime.toDate()
            )
          : "";

        return (
          <NotesContainerGlobalMedicalMobile
            key={note.id}
            noteContent={note.noteContent}
            effectiveDate={note.effectiveDateTime}
            noteDate={formattedDate}
            noteTime={formattedTime}
            doneBy={note.doneBy}
            timeStamp={formattedTimestamp}
            lastModification={formattedLastModification}
            clientPic={note.clientProfilePicture}
            clientFirstName={note.clientFirstName}
            clientLastName={note.clientLastName}
            noteId={note.id}
            fileUrls={note.fileUrls}
            {...note}
          />
        );
      })}
    </div>
  );
}

export default MedicalNotesAllMobile;
